import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../../../components/Header";
import Footer from "../../../../components/Footer";
import "../../styleAllServices.css";
import limeImg from "../../../../assets/img/lawn-care-professional-lime-treatment.jpg";
import soilImg from "../../../../assets/img/soil-sample-lawn-health.jpg";

export default function Liming() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    let linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) { linkTag.setAttribute("href", canonicalUrl); }
    else {
      linkTag = document.createElement("link");
      linkTag.setAttribute("rel", "canonical");
      linkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(linkTag);
    }
    document.title = "Lawn Liming Vancouver | pH Correction for Healthy Lawns | BUR-HAN";
    const desc = "Professional lawn liming in Vancouver. Correct soil pH, reduce moss and improve fertilizer effectiveness with BUR-HAN's expert lime treatments. Free quote: 604-983-2687";
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) { metaDesc.setAttribute("content", desc); }
    else {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      metaDesc.setAttribute("content", desc);
      document.head.appendChild(metaDesc);
    }
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) { ogTitle.setAttribute("content", document.title); }
    else {
      ogTitle = document.createElement("meta");
      ogTitle.setAttribute("property", "og:title");
      ogTitle.setAttribute("content", document.title);
      document.head.appendChild(ogTitle);
    }
    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) { ogDesc.setAttribute("content", desc); }
    else {
      ogDesc = document.createElement("meta");
      ogDesc.setAttribute("property", "og:description");
      ogDesc.setAttribute("content", desc);
      document.head.appendChild(ogDesc);
    }
  }, [location.pathname]);

  return (
    <div className="wrapper">
      <Header />
      <div className="serviceItemsHeader">
        <h1 data-aos="zoom-in">Lawn Liming Vancouver</h1>
      </div>
      <div className="serviceItemsMain">
        <h2 data-aos="fade-down">
          "Balance your soil pH for a healthier, greener, thicker lawn."
        </h2>
        <hr />
        <section className="section-container">
          <div className="image-container px-5" data-aos="fade-right">
            <img loading="lazy" src={limeImg}
              alt="BUR-HAN professional applying lime treatment to a Vancouver lawn"
              title="Professional Lawn Liming Service in Vancouver"
            />
          </div>
          <div className="text-container px-5" data-aos="fade-up">
            <h3 className="headingImageText text-uppercase">What Is Lawn Liming?</h3>
            <p>
              Vancouver's soils are naturally acidic due to the region's high rainfall and decomposing organic matter. When soil pH drops too low, grass struggles to absorb nutrients even when fertilizer is applied — leading to thin, pale, moss-prone lawns. Liming corrects this by raising soil pH back to the ideal range of 6.0–7.0, where grass roots thrive.
            </p>
            <p>
              BUR-HAN applies agricultural limestone (calcitic or dolomitic lime) at the right rate for your lawn's current pH level. With proper liming, your lawn can finally access the nutrients it needs for lush growth and vibrant color.
            </p>
          </div>
        </section>
        <section className="section-container">
          <div className="text-container px-5" data-aos="fade-up">
            <h3 className="headingImageText text-uppercase">Benefits of Liming Your Lawn</h3>
            <ul>
              <li><strong>Unlocks nutrients:</strong> Lime allows your lawn to actually absorb the fertilizer you're applying — without it, nutrients stay locked in acidic soil.</li>
              <li><strong>Reduces moss:</strong> Moss thrives in acidic, nutrient-poor conditions. Correcting pH is one of the most effective long-term moss management strategies.</li>
              <li><strong>Improves soil structure:</strong> Calcium in lime improves soil particle aggregation, leading to better drainage and root penetration.</li>
              <li><strong>Enhances grass density:</strong> A lawn with the right pH produces thicker, greener grass that naturally crowds out weeds and moss.</li>
              <li><strong>Boosts fertilizer ROI:</strong> Liming maximizes the return on every fertilizer application by making nutrients available to grass roots.</li>
            </ul>
          </div>
          <div className="image-container px-5" data-aos="fade-left">
            <img loading="lazy" src={soilImg}
              alt="Soil sample showing pH levels for lawn liming assessment in Vancouver"
              title="Soil pH Testing Before Lime Treatment"
              style={{ maxHeight: "35vw", width: "auto", margin: "0 auto", display: "block" }}
            />
          </div>
        </section>

        <section className="lawnCareLinks" data-aos="fade-up">
          <h2>More Residential Lawn Care Services</h2>
          <div className="lawnCareLinks-grid">
      <a href="/services/residential-lawn-care">
        <strong>Residential Lawn Care</strong>
        <span>All lawn care services</span>
      </a>
      <a href="/services/residential-lawn-care/moss-control">
        <strong>Moss Control</strong>
        <span>Treatment & prevention</span>
      </a>
      <a href="/services/residential-lawn-care/organic-weed-control">
        <strong>Organic Weed Control</strong>
        <span>Pesticide-free weed management</span>
      </a>
      <a href="/services/residential-lawn-care/topdressing">
        <strong>Topdressing</strong>
        <span>Compost & soil improvement</span>
      </a>
      <a href="/services/residential-lawn-care/overseeding">
        <strong>Overseeding</strong>
        <span>Thicken & repair your lawn</span>
      </a>
          </div>
        </section>
        <div className="secondBanner">
          <div className="container" data-aos="fade-down">
            <div className="row">
              <div className="col-md-6">
                <h3>Ready to elevate your outdoor experience?</h3>
                <p>Fill out our Get a Quote page, and let our expert lawn care team assess your soil and recommend the right lime treatment for your Vancouver property.</p>
              </div>
              <div className="col-md-6">
                <div className="call-to-action text-right">
                  <a href="/contact-us" className="get-a-quote">Get A Quote</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
